$ = require 'jquery'
{ avatarDomain } = require '@trello/config'
React = require 'react'
t = require('app/scripts/views/internal/recup-with-helpers')('canonical_comment')
Controller = require 'app/scripts/controller'
TFM = require 'app/scripts/lib/markdown/tfm'
{ isForceSubmitEvent } = require '@trello/keybindings'
Avatar = require('@atlassian/trello-canonical-components').CanonicalAvatar
{
  ButtonLink
  Icon
  ReplyActions
  ReplyColumnAvatar
  ReplyColumnContent
  ReplyColumns
  ReplyContainer
  ReplyLink
  ReplySentText
  ReplyTextarea
  ForwardIcon
} = require('@atlassian/trello-canonical-components').CanonicalDetail

module.exports = class CanonicalCommentInlineReply extends React.Component
  displayName: 'CanonicalCommentInlineReply'

  constructor: (props) ->
    super(props)

    @state = { sentAnimationComplete: false }

    @sentAnimationTimeout = null

    @onKeyDown = @onKeyDown.bind(@)

  componentDidMount: ->
    $('.js-text').on 'mutated', @changeReplyMessage

  componentWillUnmount: ->
    if @sentAnimationTimeout?
      clearTimeout(@sentAnimationTimeout)

    $('.js-text').off 'mutated', @changeReplyMessage

  componentWillReceiveProps: (nextProps) ->
    if (nextProps.hasReplied != @props.hasReplied)
      if @sentAnimationTimeout?
        clearTimeout(@sentAnimationTimeout)

      @sentAnimationTimeout = setTimeout(=>
        @setState(sentAnimationComplete: nextProps.hasReplied)
      , 2000)

  changeReplyMessage: (event) =>
    @props.onChangeReplyMessage(event)

  onKeyDown: (e) =>
    { onSaveClick } = @props
    if isForceSubmitEvent(e)
      onSaveClick()

  render: t.renderable ->
    {
      memberCreator
      onSaveClick
      onCancelClick
      onChangeReplyMessage
      onDismissClick
      replyAction
      replyMessage
      replyFailedStatusCode
      isReplying
      isWaitingForNetworkResponse
      hasReplied
      setFocusedCard
    } = @props

    { sentAnimationComplete } = @state

    avatarHash = memberCreator?.get('avatarHash')

    t.tag ReplyContainer, =>
      if isReplying
        t.tag ReplyColumns, key: 'reply-textarea', =>
          t.tag ReplyColumnAvatar, =>
            t.tag Avatar, {
              lightBackground: true
              key: memberCreator?.id
              deactivated: memberCreator?.get('isDeactivated')
              img: avatarHash and [avatarDomain, avatarHash, '30.png'].join('/')
              img2x: avatarHash and [avatarDomain, avatarHash, '50.png'].join('/')
              initials: memberCreator?.get('initials')
            }
          t.tag ReplyColumnContent, =>
            t.tag ReplyTextarea, {
              value: replyMessage
              onChange: onChangeReplyMessage
              className: 'canonical-reply-text-area js-text'
              onFocus: setFocusedCard
              onKeyDown: @onKeyDown
            }
            if !replyFailedStatusCode
              if !isWaitingForNetworkResponse
                t.tag ReplyActions, =>
                  t.tag ButtonLink, {
                    disabled: !replyMessage
                    onClick: onSaveClick
                    className: 'canonical-reply-button-link'
                  }, =>
                    t.format 'save'
                  t.tag ButtonLink, {
                    onClick: onCancelClick
                    className: 'canonical-reply-button-link'
                  }, =>
                    t.format 'cancel'
              else
                t.span { class: t.classify('sending-spinner': true) }, ->
                  t.format 'sending-ellipsis'
      else if hasReplied
        if sentAnimationComplete && replyAction
          t.tag ReplyLink, {
            key: 'reply-link'
            href: if replyAction.id then Controller.getActionUrl(replyAction) else null
           }, =>
            t.tag ReplyColumns, centered: 'true', =>
              t.tag ReplyColumnAvatar, {
                className: 'canonical-reply-sent-avatar'
              }, =>
                t.tag Avatar, {
                  lightBackground: true
                  size: 24
                  key: memberCreator?.id
                  deactivated: memberCreator?.get('isDeactivated')
                  img: avatarHash and [avatarDomain, avatarHash, '30.png'].join('/')
                  img2x: avatarHash and [avatarDomain, avatarHash, '50.png'].join('/')
                  initials: memberCreator?.get('initials')
                }
              t.tag ReplyColumnContent, =>
                t.tag ReplySentText, =>
                  t.text TFM.comments.text(replyAction.get('data').text).output
              t.tag Icon, {
                height: 16
                width: 16
                className: 'canonical-reply-link-icon'
              }, =>
                t.tag ForwardIcon
        else
          t.tag ReplyColumns, {
            key: 'reply-sent'
            centered: true
          }, =>
            t.tag ReplyColumnContent, =>
              t.tag ReplySentText, { centered: true }, =>
                t.format 'reply-sent'
      if replyFailedStatusCode
        t.tag ReplyContainer, =>
          t.tag ReplyColumns, {
            key: 'card-not-found'
            centered: true
          }, =>
            t.tag ReplyColumnContent, =>
              t.tag ReplySentText, {
                centered: true
              }, =>
                t.format if replyFailedStatusCode == 404 then 'not-found' else 'not-found-generic'
                if replyFailedStatusCode == 404
                  t.tag ReplyActions, =>
                    t.tag ButtonLink, {
                      onClick: onDismissClick
                      className: 'canonical-reply-button-link'
                    }, =>
                      t.format 'got-it-dismiss'
